"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconChevronRight', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10.7072 7.29325C11.0982 7.68425 11.0982 8.31625 10.7072 8.70725L6.70724 12.7072C6.31624 13.0982 5.68424 13.0982 5.29324 12.7072C4.90224 12.3162 4.90224 11.6842 5.29324 11.2932L8.58624 8.00025L5.29324 4.70725C5.09824 4.51225 5.00024 4.25625 5.00024 4.00025C5.00024 3.74425 5.09824 3.48825 5.29324 3.29325C5.68424 2.90225 6.31624 2.90225 6.70724 3.29325L10.7072 7.29325Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M11.5862 10L6.29324 15.293C5.90224 15.684 5.90224 16.316 6.29324 16.707C6.68424 17.098 7.31624 17.098 7.70724 16.707L13.7072 10.707C14.0982 10.316 14.0982 9.684 13.7072 9.293L7.70724 3.293C7.51224 3.098 7.25624 3 7.00024 3C6.74424 3 6.48824 3.098 6.29324 3.293C5.90224 3.684 5.90224 4.316 6.29324 4.707L11.5862 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M13.9035 12L7.5519 18.3516C7.0827 18.8208 7.0827 19.5792 7.5519 20.0484C8.0211 20.5176 8.7795 20.5176 9.2487 20.0484L16.4487 12.8484C16.9179 12.3792 16.9179 11.6208 16.4487 11.1516L9.2487 3.9516C9.0147 3.7176 8.7075 3.6 8.4003 3.6C8.0931 3.6 7.7859 3.7176 7.5519 3.9516C7.0827 4.4208 7.0827 5.1792 7.5519 5.6484L13.9035 12Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M18.538 16L10.0692 24.4688C9.44362 25.0944 9.44362 26.1056 10.0692 26.7312C10.6948 27.3568 11.706 27.3568 12.3316 26.7312L21.9316 17.1312C22.5572 16.5056 22.5572 15.4944 21.9316 14.8688L12.3316 5.26879C12.0196 4.95679 11.61 4.79999 11.2004 4.79999C10.7908 4.79999 10.3812 4.95679 10.0692 5.26879C9.44362 5.89439 9.44362 6.90559 10.0692 7.53119L18.538 16Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;